export default __webpack_public_path__ + "static/media/twitter.7121d0a9.png";